module.exports = __webpack_public_path__ + "static/img/maskCount.d7efe3e4.png";